export default "__VITE_ASSET__BvBtzKF$__"